import { actionGenerator } from '../../utils/redux/actionGenerator';
import { IGeoCodeCachedResponse } from '../../repositories/monolith-cian-realty/entities/Models/GeoCodeCachedResponse';

export enum EActionTypes {
  GetGeocode = 'geocode/Request',
}

export const getGeocodeRequest = actionGenerator<EActionTypes.GetGeocode, IGeoCodeCachedResponse>(
  EActionTypes.GetGeocode,
);

type TGetGeocodeRequestAction = ReturnType<typeof getGeocodeRequest>;

export type TGeocodeActions = TGetGeocodeRequestAction;
